<template>
  <div>
    <activity-flow-card
      card_title="Equipos"
      extra-class="bg-green"
      :data="reportData"
      :map-data="{ title: 'Title', qty: 'Qty' }"
      :loading="loading"
      @click-item-qty="handleClickLink"
    >
    </activity-flow-card>

    <rabbey-base-drawer :drawer.sync="drawer" size="80%" :title="title">
      <CardStatDrawerHeader
        :itemQuantity="itemQuantity"
        :totalAmount="totalAmount"
        :totalInvoice="totalInvoice"
        :Title="title"
      />

      <rabbey-toolbox :filterables="true" @filter-search="search = $event" />
      <rabbey-table3
        :data="items"
        :search="search"
        :columns="columns"
        :stripe="true"
      ></rabbey-table3>
    </rabbey-base-drawer>
  </div>
</template>

<script>
import axios from "axios";
import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
import { GPSLastConnectionColumns } from "@/columns/GPSLasConnectionsColumns";
import { helperGetColumsItems } from "./utils.js";
import CardStatDrawerHeader from "./CardStatDrawerHeader.vue";

export default {
  name: "EquipmentStat",
  props: {
    employee: {
      type: [String, Number]
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityFlowCard,
    CardStatDrawerHeader
  },
  created() {
    //this.getReportData();
    this.GetOfflineGPSs();
  },
  data() {
    return {
      reportData: [],
      loading: false,
      title: "",
      dialogVisible: false,
      drawer: false,
      search: "",
      columns: [],
      items: [],
      itemQuantity: 0,
      totalAmount: 0,
      totalInvoice: 0,
      request: null, // cancelation token
      mapColumns: {
        LastConnectionLess48Hours: GPSLastConnectionColumns,
        LastConnectionMore7: GPSLastConnectionColumns,
        LastConnectionMore15: GPSLastConnectionColumns,
        LastConnectionMore30: GPSLastConnectionColumns
      }
    };
  },
  methods: {
    /*
    getReportData() {
      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetEquipment", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            UserName: this.currentUser.UserName,
            EmployeeId: this.employee,
            PersonCode: this.currentUser.PersonCode
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          console.log("reportData: ",this.reportData)
          this.loading = false;
        })
        .catch((error) => console.error(error));
    },
    */
    GetOfflineGPSs: async function () {
      let trackersCount = await this.$store.dispatch("navixy/getTotalGps");
      trackersCount;
      //console.log("trackersCount: ",trackersCount);
      let NavUsersCount = await this.$store.dispatch("navixy/getTotalUsers");
      NavUsersCount;
      //console.log("NavUsersCount: ",NavUsersCount);
      this.loading = true;
      let trackers = this.$store.getters["navixy/getTrackers"];
      let NavUsers = this.$store.getters["navixy/getUserList"];

      let OfflineTrackers = trackers.filter(
        (t) => t.source.connection_status === "offline"
      );
      let customersWithContact;

      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      await this.$http
        .get("/api/customers/GetCustomersWithContacts", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            Page: 1,
            Limit: 1000000,
            CompanyId: this.currentCompany,
            SalesPersonCode: null,
            Name: null,
            CustomerService: null,
            Contract: null,
            AccountReceivable: null,
            clasificaction: null,
            ClientType: null
          }
        })
        .then((response) => {
          //console.log("CustomerList: ", response);
          customersWithContact = response.data.Items;
          // console.log("klk data gps",OfflineTrackers)
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });

      let actualDate = new Date();
      OfflineTrackers.forEach((ot) => {
        ot.user = NavUsers.filter((nu) => nu.id === ot.user_id)[0];
        ot.client = customersWithContact.filter(
          (cust) => cust.ClientCode === ot.user.post_region
        )[0];
        ot.daysOffline = Math.round(
          Math.abs(
            new Date(ot.last_connection).getTime() - actualDate.getTime()
          ) /
            (1000 * 3600 * 24)
        );
      });
      let Titkes = [
        { title: "GPS Fuera de línea de 2 a 6 días", myq: 2, mnq: 6 },
        { title: "GPS Fuera de línea de 7 a 14 días", myq: 6, mnq: 14 },
        { title: "GPS Fuera de línea de 15 a 29 días", myq: 14, mnq: 29 },
        { title: "GPS Fuera de línea de 30 a más días", myq: 29, mnq: null }
      ];

      Titkes.forEach((t) => {
        this.reportData.push({
          Title: t.title,
          Qty: this.FilteringByDaysOffline(OfflineTrackers, t.myq, t.mnq)
            .length,
          LastConnectionLess48Hours: this.FilteringByDaysOffline(
            OfflineTrackers,
            t.myq,
            t.mnq
          ),
          LastConnectionMore7: this.FilteringByDaysOffline(
            OfflineTrackers,
            t.myq,
            t.mnq
          ),
          LastConnectionMore15: this.FilteringByDaysOffline(
            OfflineTrackers,
            t.myq,
            t.mnq
          ),
          LastConnectionMore30: this.FilteringByDaysOffline(
            OfflineTrackers,
            t.myq,
            t.mnq
          )
        });
      });
      //console.log("OfflineTrackers: ",OfflineTrackers);
    },

    FilteringByDaysOffline(OfflineTrackers, mayorQue, menorIgualQue) {
      let FilteredOfflineTrackers = [];
      if (menorIgualQue !== null) {
        FilteredOfflineTrackers = OfflineTrackers.filter(
          (offtrack) =>
            offtrack.daysOffline > mayorQue &&
            offtrack.daysOffline <= menorIgualQue
        );
      } else {
        FilteredOfflineTrackers = OfflineTrackers.filter(
          (offtrack) => offtrack.daysOffline > mayorQue
        );
      }

      return FilteredOfflineTrackers;
    },
    handleClickLink(props) {
      //console.log(props, "\n ReportData: ", this.reportData);
      const report = this.reportData.find((f) => f.Title === props.title);
      const { items, columns } = helperGetColumsItems(report, this.mapColumns);
      this.items = items;
      this.columns = columns;
      this.title = props.title;
      this.drawer = true;

      this.totalAmount = props.qty; // Gets total items to display it on the header of the drawer
      this.itemQuantity = this.items.length; // Gets total items to display it on the header of the drawer
      this.totalInvoice = this.items.length;
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    }
  }
};
</script>

<style></style>
